// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback } from 'react';

import { type AuthReturn, removeLocalStorage, useEvolvePost } from '@evolvemep/api-ts';

import { setLocalStorageWrapped } from 'hooks/useLocalStorage';

export const useSignIn = () => {
  const { apiCall } = useEvolvePost('admin/authentication', { alertOnError: false });

  const signIn = useCallback(
    async ({
      email,
      password,
      keepEnabled,
    }: {
      email: string;
      password: string;
      keepEnabled: boolean;
    }): Promise<AuthReturn> => {
      removeLocalStorage('EVOLVE_ACCESS_TOKEN');
      const authResult = await apiCall({ userName: email, password });

      if (keepEnabled) {
        // Hardcoded as localStorage.setItem so that it can be read within `useLocalStorage`,
        // bypassing the localStorage/sessionStorage check
        localStorage.setItem('STAY_SIGNED_IN', 'true');
      }

      setLocalStorageWrapped('EVOLVE_ACCESS_TOKEN', authResult.accessToken);
      setLocalStorageWrapped('EVOLVE_REFRESH_TOKEN', authResult.refreshToken);
      setLocalStorageWrapped('EVOLVE_TOKEN_USERNAME', authResult.tokenUserName);

      return authResult;
    },
    [apiCall],
  );

  return { signIn };
};
